import { render, staticRenderFns } from "./CustomerWeeklyOverview.vue?vue&type=template&id=4d6704ee&scoped=true&"
import script from "./CustomerWeeklyOverview.vue?vue&type=script&lang=ts&"
export * from "./CustomerWeeklyOverview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6704ee",
  null
  
)

export default component.exports